export type PillarScores = {
  stock: number
  wait: number
  care: number
}

export type Pharmacy = {
  id: string
  name: string
  category: 'Independent' | 'Chain'
  address: string
  neighborhood: string
  coordinates: {
    latitude: number
    longitude: number
  }
  footTraffic: {
    status: 'Quiet' | 'Moderate' | 'Busy'
    summary: string
    recentReports: number
    typicalWaitMinutes: number
  }
  scores: PillarScores
  reviewCount: number
  claimed: boolean
}

export type Review = {
  id: string
  reviewer: string
  scores: PillarScores
  reason: string
  timestamp: string
  body: string
}

export const pharmacies: Pharmacy[] = [
  {
    id: 'northridge',
    name: 'Northridge Family Pharmacy',
    category: 'Independent',
    address: '2140 W Northridge Ave',
    neighborhood: 'Northridge',
    coordinates: { latitude: 41.9352, longitude: -87.6826 },
    footTraffic: {
      status: 'Moderate',
      summary:
        'A steady after-lunch flow, with a few recent reports of short pickup lines.',
      recentReports: 6,
      typicalWaitMinutes: 12,
    },
    scores: { stock: 4.2, wait: 3.8, care: 4.9 },
    reviewCount: 124,
    claimed: false,
  },
  {
    id: 'lakeview',
    name: 'Lakeview Community Rx',
    category: 'Independent',
    address: '822 W Belmont Ave',
    neighborhood: 'Lakeview',
    coordinates: { latitude: 41.9396, longitude: -87.6498 },
    footTraffic: {
      status: 'Quiet',
      summary:
        'Recent neighbor check-ins suggest an easygoing pickup window right now.',
      recentReports: 4,
      typicalWaitMinutes: 7,
    },
    scores: { stock: 4.7, wait: 4.3, care: 4.8 },
    reviewCount: 89,
    claimed: true,
  },
  {
    id: 'wellcare',
    name: 'WellCare Pharmacy',
    category: 'Chain',
    address: '505 N Michigan Ave',
    neighborhood: 'River North',
    coordinates: { latitude: 41.8919, longitude: -87.6246 },
    footTraffic: {
      status: 'Busy',
      summary:
        'Community check-ins point to a fuller counter and longer afternoon pickup line.',
      recentReports: 11,
      typicalWaitMinutes: 19,
    },
    scores: { stock: 4.6, wait: 3.2, care: 3.9 },
    reviewCount: 217,
    claimed: true,
  },
  {
    id: 'parkway',
    name: 'Parkway Health Pharmacy',
    category: 'Independent',
    address: '1865 N Milwaukee Ave',
    neighborhood: 'Wicker Park',
    coordinates: { latitude: 41.9146, longitude: -87.6778 },
    footTraffic: {
      status: 'Moderate',
      summary:
        'A consistent neighborhood pace, with recent reports of a brief consultation queue.',
      recentReports: 5,
      typicalWaitMinutes: 10,
    },
    scores: { stock: 3.9, wait: 4.6, care: 4.5 },
    reviewCount: 52,
    claimed: false,
  },
]

export const northridgeReviews: Review[] = [
  {
    id: 'maria',
    reviewer: 'Maria G.',
    scores: { stock: 5, wait: 4, care: 5 },
    reason: 'Refill pickup',
    timestamp: '3 days ago',
    body: 'Staff remembered my name and had my medication ready before I reached the counter. They also walked me through a coverage question without making me feel rushed.',
  },
  {
    id: 'trevor',
    reviewer: 'Trevor L.',
    scores: { stock: 4, wait: 3, care: 5 },
    reason: 'New prescription',
    timestamp: '1 week ago',
    body: 'My prescription was in stock, and the pharmacist took time to explain a new medication. The line moved slowly after work, but the care felt personal.',
  },
  {
    id: 'dana',
    reviewer: 'Dana R.',
    scores: { stock: 4, wait: 5, care: 4 },
    reason: 'Vaccine appointment',
    timestamp: '2 weeks ago',
    body: 'Easy check-in and no waiting around. I appreciate that they gave clear follow-up instructions and called the next day to make sure I was okay.',
  },
]

export const peakWaitData = [
  { label: '9a', value: 24 },
  { label: '11a', value: 41 },
  { label: '1p', value: 62 },
  { label: '3p', value: 86 },
  { label: '5p', value: 100 },
  { label: '7p', value: 48 },
]
